export const getIntegrationsUrl = () => 'agency/available_integrations';
export const getAllIntegrationsUrl = () => 'agency/available_integrations/all';
export const getIntegrationUrl = (id: string) => `agency/available_integrations/${id}`;
export const getAvailableToolsUrl = (id: string) => `agency/available_integrations/${id}/integration_tools`;
export const getCatalogAvailableToolsUrl = (code: string) =>
  `agency/available_integrations/catalog/${code}/integration_tools`;
export const purchaseCatalogIntegrationUrl = (code: string) => `agency/available_integrations/catalog/${code}/purchase`;
export const getAgentTemplateMoreDataUrl = () => 'agency/agent_templates/read_more_data';
export const getHelpCenterArticleUrl = (id: string | number) => `help_center/articles/${id}`;
